import { useState } from 'react';
import { useField } from 'formik';
import { Stack } from '@koob/margaret';
import { KoobFormikInput } from '@koob/ui';
import {
  FormField,
  FormLabel,
  ErrorMessageWrapper,
  HelperText,
} from 'ui/forms';
import { uniqueId } from 'lodash';

const TextField = ({
  label,
  labelSuffix,
  variant = '',
  helperText,
  touchRequired = true,
  required,
  errorKey,
  suffixIcon,
  suffix,
  name,
  ...props
}) => {
  const [field, meta, helpers] = useField(name);
  const fieldForError = useField(errorKey ?? name);
  const [id] = useState(uniqueId());
  const hasError =
    (!touchRequired || Boolean(meta.touched)) &&
    Boolean(fieldForError[1].error);

  const renderInput = (iconRight) => (
    <KoobFormikInput
      field={field}
      setValue={helpers.setValue}
      {...props}
      error={hasError}
      id={id}
      iconRight={iconRight}
    />
  );

  if (variant === 'inline') {
    return (
      <Stack alignY="center" gutterSize={label ? 0.5 : 0}>
        <FormLabel variant="bare" htmlFor={id}>
          {label}
          {required && <span className="ml-1 text-red-500">*</span>}
        </FormLabel>
        <Stack>{renderInput(suffix)}</Stack>
      </Stack>
    );
  }

  return (
    <FormField>
      {(Boolean(label) || Boolean(labelSuffix)) && (
        <Stack
          alignX="space-between"
          alignY="center"
          marginBottom={0.5}
          size="full"
        >
          {label && (
            <FormLabel variant="bare" htmlFor={id}>
              {label}
              {required && <span className="ml-1 text-red-500">*</span>}
            </FormLabel>
          )}
          {labelSuffix}
        </Stack>
      )}
      <Stack size="full" alignY="start" direction="column">
        {renderInput(suffixIcon ?? suffix)}
        {hasError && (
          <ErrorMessageWrapper>{fieldForError[1].error}</ErrorMessageWrapper>
        )}
      </Stack>
      {Boolean(helperText) && <HelperText>{helperText}</HelperText>}
    </FormField>
  );
};

export default TextField;
